import useAuth from "../hooks/useAuth";

export const useSupportAreaArray = () => {
  const { isAdmin } = useAuth();

  const supportAreaArray = [
    { label: "Startseite", value: "Dashboard" },
    isAdmin ? { label: "Praxis", value: "Praxisseite" } : null,
    isAdmin ? { label: "Benutzer", value: "Benutzerseite" } : null,
    { label: "Aufgaben", value: "Aufgabenseite" },
    { label: "Kalendar", value: "Kalendar" },
    { label: "QM-Dokumente", value: "Dateien" },
    {
      label: "Fehler-/Beschwerden- & Risikomanagement",
      value: "Fehler-/Beschwerden- & Risikomanagement",
    },
    { label: "Audit", value: "Audit" },
    { label: "Neuigkeiten", value: "Neuigkeiten" },
    { label: "Gesetze", value: "Gesetze" },
    { label: "Befragung", value: "Befragung" },
    { label: "Profil", value: "Profil" },
    { label: "Einstellungen", value: "Einstellungen" },
    { label: "Sonstige Anliegen", value: "sonstige" },
  ].filter(Boolean);

  return supportAreaArray;
};
